// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__2G5q6","author":"Table_author__3hXJU","authorImage":"Table_authorImage__1JDK4","unreadRow":"Table_unreadRow__2wNrE"};